import { configureStore } from "@reduxjs/toolkit";
import { postsReducer } from "./posts/postsSlice";
import { usersReducer } from "./users/usersSlice";
import { messagesSlice } from "./messages/messagesSlice";

export const store = configureStore({
  reducer: {
    posts: postsReducer,
    users: usersReducer,
    messages: messagesSlice.reducer,
  },
});
